const action = (router, method, field, values) => router[method]({ [field]: { ...router.currentRoute.value[field], ...values } });

export const replaceParams = (router, obj) => action(router, 'replace', 'params', obj);
export const replaceQuery = (router, obj) => action(router, 'replace', 'query', obj);
export const pushParams = (router, obj) => action(router, 'push', 'params', obj);
export const pushQuery = (router, obj) => action(router, 'push', 'query', obj);
